/**
 * Client contact validation schema
 * Validates contact person data for clients
 */

import * as Yup from 'yup'
import { FORM_LABELS, LABELS } from '@constants'
import { createEmailValidator } from '@utilities/validation'

/**
 * Client contact validation schema
 * Simple validation for contact person fields
 */
export const clientContactValidationSchema = () =>
  Yup.object().shape({
    first_name: Yup.string()
      .required(FORM_LABELS.REQUIRED('Voornaam'))
      .max(255, FORM_LABELS.MAX_LENGTH('Voornaam', 255)),

    last_name: Yup.string()
      .required(FORM_LABELS.REQUIRED('Achternaam'))
      .max(255, FORM_LABELS.MAX_LENGTH('Achternaam', 255)),

    email: createEmailValidator(FORM_LABELS.INVALID_EMAIL)
      .required(FORM_LABELS.REQUIRED(LABELS.EMAIL))
      .max(255, FORM_LABELS.MAX_LENGTH(LABELS.EMAIL, 255)),

    phone: Yup.string().default('').max(20, FORM_LABELS.MAX_LENGTH('Telefoonnummer', 20)),

    department: Yup.string().default('').max(255, FORM_LABELS.MAX_LENGTH('Afdeling', 255)),
  })
